import * as React from 'react'
import {MouseEventHandler} from 'react'

type Props = {
    label: string
    onClick?: MouseEventHandler<HTMLButtonElement>
    size?: 'is-large' | 'is-medium' | 'is-small'
    position?: 'centered' | 'left' | 'right'
    buttonId?: string
}

const SubmitButton = ({onClick, label, size = 'is-large', position = 'centered', buttonId}: Props) => {
    const isSmall = size === 'is-medium' || size === 'is-small'

    return (
        <div
            className={`field is-grouped is-grouped-${position}`}
            style={{marginTop: isSmall ? '1.5rem' : '3rem', marginBottom: 0}}
        >
            <div className="control">
                <button
                    id={buttonId}
                    type="button"
                    className={`button is-primary ${size} is-rounded`}
                    onClick={onClick}
                >
                    {label}
                </button>
            </div>
        </div>
    )
}

export default SubmitButton
